<div v-if="imagePath"
     class="image-box">
    <div v-if="type === 'chart'" class="image-box__wrap-ranking">
        <div class="image-box__ranking" v-html="ranking"></div>
    </div>
    <div class="image-box__container-image"
        @click="openModal(imagePath)">
        <img class="image-box__image"
             :src="require('../../assets/contest/' + imagePath)"
            alt="Image Contest"
        />
    </div>
    <div v-if="type === 'contest' && contestActive"
         class="image-box__rating"
         @click="voteImage(pid, imagePath)">
        <i :class="[selected ? 'icon-mb-like-selected' : 'icon-mb-like']"></i>
    </div>
</div>